import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    get: async () => exeRequest(`/admin/demandes-assistances`, 'GET'),
    getList: async (params) => exeRequest(`/admin/demandes-assistances${buildQuery(params)}`, 'GET'),

    traiterDemandeAssistance: async (id, data) =>exeRequest(`/admin/demandes-assistances/${id}`, 'PUT', data),
};
